module.exports = __webpack_public_path__ + "static/stewart-sutherland-recruitment-videov2-0e6da0160f721d48d079c6c40a98e8d1.mp4";